import { forwardRef } from "react";

import { cn } from "@/lib/utils";

import { Input } from "./ui/input";

interface IStyledInputProps extends React.ComponentProps<typeof Input> {
  wrapperClassName?: string;
  isError?: boolean;
}

export const StyledInput = forwardRef<HTMLInputElement, IStyledInputProps>(
  ({ wrapperClassName, className, isError, ...props }, ref) => {
    return (
      <div className={cn("relative", wrapperClassName)}>
        <Input
          ref={ref}
          className={cn(
            // NOTE: NSAI-6259 follow-up — 40px, was 48px. This sat a full 12px taller
            // than the buttons beside it on the same forms, which is what made the
            // profile fields look oversized next to their own Edit and Email
            // controls. Still a touch roomier than the bare `Input` (36px),
            // because these are the main fields of a settings form.
            "bg-input-background h-10 focus-visible:ring-1 focus-visible:ring-offset-0 focus-visible:border-ring",
            isError &&
              "border-destructive focus-visible:border-destructive focus-visible:ring-destructive",
            className,
          )}
          {...props}
        />
      </div>
    );
  },
);

StyledInput.displayName = "StyledInput";
